import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
    name: "not-found-view",
})
export default class NotFoundView extends Vue {}
